<svelte:head>
	<script type="application/ld+json">
		{
			"@context": "https://schema.org",
			"@type": "ProfilePage",
			"mainEntity": {
				"@type": "Person",
				"name": "Sam Greening",
				"description": "Composer, Pianist, and Electronic Musician."
			}
		}
	</script>
</svelte:head>
